import { render } from "./dailyReports.vue?vue&type=template&id=6c5b860a"
import script from "./dailyReports.vue?vue&type=script&lang=js"
export * from "./dailyReports.vue?vue&type=script&lang=js"

import "./dailyReports.vue?vue&type=style&index=0&id=6c5b860a&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__